// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__E35Y0","resendInfoText":"OnGoingPaymentBox_resendInfoText__16Sit"};